import { jsx } from "react/jsx-runtime";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import { validateTidalLicense } from "../../base/index.js";
function MonetizationOn(props) {
  return /* @__PURE__ */ jsx(
    MonetizationOnIcon,
    {
      "data-testid": "MonetizationOn",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "MonetizationOn",
      "data-tidal-icon-meta": "money,invoices,payments"
    }
  );
}
MonetizationOn.tidalIconMeta = {
  categories: "money,invoices,payments",
  name: "MonetizationOn"
};
validateTidalLicense();
export {
  MonetizationOn
};
//# sourceMappingURL=MonetizationOn.js.map
